"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFeatherOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.feather_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "feather_outline_svg__transparent_box" },
            React.createElement("path", { className: "feather_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "feather_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "feather_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M2 24h28v2H2zM29.56 6.09a15.64 15.64 0 00-8.66-2.15l-.63.06-1.48 3.37-1.23-2.72-.93.35a76.15 76.15 0 00-7.1 3l-.4.2L7.19 14a15.41 15.41 0 01-5-.09l-.42 2.1a15.88 15.88 0 003.07.29 21.75 21.75 0 002.94-.22l4.9 2.95H13a27.19 27.19 0 0010.11-2.23c5.47-2.25 6.89-9.3 6.94-9.6l.14-.72zm-7.3 8.79a25.43 25.43 0 01-9 2l-2.35-1.38a29.75 29.75 0 004.53-1.5l-.88-2a31 31 0 01-5 1.59l1.29-3.86c1.8-.87 3.64-1.66 5.57-2.41L18 10.8l1.92-.71L21.72 6a13.46 13.46 0 016 1.52c-.44 1.74-1.96 5.9-5.46 7.36z" }))));
}
exports.default = SvgFeatherOutline;
//# sourceMappingURL=FeatherOutline.js.map